<script>
import autosize from 'autosize';
import { mapMutations } from 'vuex';

export default {
  name: 'CommentForm',
  props: {
    placeholder: {
      type: String,
      default: 'Your comment'
    }
  },
  data() {
    return {
      maxLength: 150
    };
  },
  computed: {
    comment: {
      get() {
        return this.$store.state.donation.comment || '';
      },
      set(value) {
        this.SET_COMMENT(value || null);
      }
    },
    characterCount() {
      return this.comment ? this.comment.length : 0;
    },
    helpText() {
      return `${this.characterCount} / ${this.maxLength}${this.characterCount === 1 ? ' Character' : ' Characters'}`;
    }
  },
  methods: {
    ...mapMutations('donation', ['SET_COMMENT']),

    async validate() {
      this.$refs.hiddenSubmitButton?.click();
      await this.$nextTick();
      const hasErrors = await this.$refs.commentFormRef?.hasValidationErrors();
      return !hasErrors;
    },

    resize(update = false) {
      const textarea = this.$refs.textarea?.$el?.querySelector('textarea');
      if (!textarea) return;

      if (update) {
        return autosize.update(textarea);
      }

      autosize(textarea);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.resize();
    });
  },
  beforeDestroy() {
    const textarea = this.$refs.textarea?.$el?.querySelector('textarea');
    if (textarea) {
      autosize.destroy(textarea);
    }
  }
};
</script>

<template>
  <formulate-form ref="commentFormRef" class="comment-form flex flex-col gap-1 w-full">
    <formulate-input
      type="textarea"
      ref="textarea"
      v-model="comment"
      :placeholder="placeholder"
      :maxlength="maxLength"
      validation="required"
      validation-name="Comment"
      @input.native="resize()"
      @focusin.native="resize(true)"
      @focusout.native="resize(true)"
      style="min-height: 84px"
      :help="helpText"
    />
    <button ref="hiddenSubmitButton" type="submit" class="hidden"></button>
  </formulate-form>
</template>
